import { render, staticRenderFns } from "./bfhs-button.vue?vue&type=template&id=c88dab80&scoped=true"
import script from "./bfhs-button.vue?vue&type=script&setup=true&lang=js"
export * from "./bfhs-button.vue?vue&type=script&setup=true&lang=js"
import style0 from "./bfhs-button.vue?vue&type=style&index=0&id=c88dab80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88dab80",
  null
  
)

export default component.exports